"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CHATWOOT_IDENTITY_KEY () {
        return CHATWOOT_IDENTITY_KEY;
    },
    get DriverClient () {
        return DriverClient;
    },
    get NC_DISABLE_GROUP_BY_AGG () {
        return NC_DISABLE_GROUP_BY_AGG;
    },
    get NC_DISABLE_GROUP_BY_LIMIT () {
        return NC_DISABLE_GROUP_BY_LIMIT;
    },
    get NC_DISABLE_SUPPORT_CHAT () {
        return NC_DISABLE_SUPPORT_CHAT;
    },
    get NC_IFRAME_WHITELIST_DOMAINS () {
        return NC_IFRAME_WHITELIST_DOMAINS;
    },
    get avoidSSL () {
        return avoidSSL;
    },
    get defaultClientPortMapping () {
        return defaultClientPortMapping;
    },
    get defaultConnectionConfig () {
        return defaultConnectionConfig;
    },
    get defaultConnectionOptions () {
        return defaultConnectionOptions;
    },
    get driverClientMapping () {
        return driverClientMapping;
    },
    get getThumbnailMaxSize () {
        return getThumbnailMaxSize;
    },
    get knownQueryParams () {
        return knownQueryParams;
    }
});
const driverClientMapping = {
    mysql: 'mysql2',
    mariadb: 'mysql2',
    postgres: 'pg',
    postgresql: 'pg',
    sqlite: 'sqlite3'
};
const defaultClientPortMapping = {
    mysql: 3306,
    mysql2: 3306,
    postgres: 5432,
    pg: 5432
};
const defaultConnectionConfig = {
    // https://github.com/knex/knex/issues/97
    // timezone: process.env.NC_TIMEZONE || 'UTC',
    dateStrings: true
};
const defaultConnectionOptions = {
    pool: {
        min: 0,
        max: +process.env.NC_DB_POOL_MAX || 10
    }
};
const avoidSSL = [
    'localhost',
    '127.0.0.1',
    'host.docker.internal',
    '172.17.0.1'
];
const knownQueryParams = [
    {
        parameter: 'database',
        aliases: [
            'd',
            'db'
        ]
    },
    {
        parameter: 'password',
        aliases: [
            'p'
        ]
    },
    {
        parameter: 'user',
        aliases: [
            'u'
        ]
    },
    {
        parameter: 'title',
        aliases: [
            't'
        ]
    },
    {
        parameter: 'keyFilePath',
        aliases: []
    },
    {
        parameter: 'certFilePath',
        aliases: []
    },
    {
        parameter: 'caFilePath',
        aliases: []
    },
    {
        parameter: 'ssl',
        aliases: []
    },
    {
        parameter: 'options',
        aliases: [
            'opt',
            'opts'
        ]
    }
];
var DriverClient = /*#__PURE__*/ function(DriverClient) {
    DriverClient["MYSQL"] = "mysql2";
    DriverClient["MYSQL_LEGACY"] = "mysql";
    DriverClient["PG"] = "pg";
    DriverClient["SQLITE"] = "sqlite3";
    DriverClient["SNOWFLAKE"] = "snowflake";
    DriverClient["DATABRICKS"] = "databricks";
    return DriverClient;
}({});
const CHATWOOT_IDENTITY_KEY = process.env.CHATWOOT_IDENTITY_KEY;
const NC_DISABLE_SUPPORT_CHAT = process.env.NC_DISABLE_SUPPORT_CHAT === 'true';
const NC_IFRAME_WHITELIST_DOMAINS = process.env.NC_IFRAME_WHITELIST_DOMAINS || '';
const NC_DISABLE_GROUP_BY_LIMIT = process.env.NC_DISABLE_GROUP_BY_LIMIT === 'true' || false;
const NC_DISABLE_GROUP_BY_AGG = process.env.NC_DISABLE_GROUP_BY_AGG === 'true' || false;
const DEFAULT_THUMBNAIL_MAX_SIZE = 3 * 1024 * 1024;
const getThumbnailMaxSize = ()=>{
    const envValue = process.env.NC_THUMBNAIL_MAX_SIZE;
    if (envValue) {
        const parsed = parseInt(envValue, 10);
        if (!isNaN(parsed) && parsed > 0) {
            return parsed;
        }
    }
    return DEFAULT_THUMBNAIL_MAX_SIZE;
};
